import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SocialFacebook = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="social-facebook"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0647 25.9733V14.7224H17.1936L17.7055 9.72235H14.0647V7.28827C14.0647 6.00017 14.0933 4.72282 15.7435 4.72282H17.4145V1.14763C17.4145 1.09447 15.98 0.973394 14.5273 0.973394C11.4945 0.973394 9.5974 3.04424 9.5974 6.84862V9.72235H6.2476V14.7224H9.5974V25.9733H14.0647Z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

SocialFacebook.defaultProps = {
  className: null,
};

SocialFacebook.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default SocialFacebook;
